<template>
    <div class="historyData-container">
        <h1>号码跟随</h1>

        <div class="lottery-selector">
            <el-select v-model="currentLottery" placeholder="请选择彩票类型" @change="clearAll">
                <el-option label="双色球红球" value="ssq"></el-option>
                <el-option label="大乐透前区" value="dlt"></el-option>
            </el-select>
        </div>

        <div class="selection-area">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>{{ currentLottery === 'ssq' ? '红球' : '前区' }}选择</span>
                    <el-tag type="info" style="margin-left: 10px;">
                    请选择{{ currentLottery === 'ssq' ? '1-6' : '1-5' }}个号码
                    </el-tag>
                    <el-tag type="warning" style="margin-left: 10px;">
                    已选 {{ selectedBalls.length }} 个
                    </el-tag>
                </div>
                <div class="ball-area">
                    <div 
                    v-for="n in ballRange" 
                    :key="`ball-${n}`" 
                    class="ball"
                    :class="{
                        selected: selectedBalls.includes(n),
                        red: currentLottery === 'ssq',
                        front: currentLottery === 'dlt'
                    }"
                    @click="toggleBall(n)"
                    >
                    {{ n < 10 ? '0'+n : n }}
                    </div>
                </div>
            </el-card>
        </div>

        <div class="control-area">
            <el-button type="primary" @click="generateCombinations" :disabled="!canGenerate">开始分析</el-button>
            <el-button @click="clearAll">清空选择</el-button>
        </div>

        <div class="result-area" v-if="Object.values(followData).length > 0">
            <el-tabs type="border-card">
                <el-tab-pane 
                    v-for="(tabKey, index) in Object.keys(followData)"
                    :key="index"
                    :label="currentLottery == 'ssq' ? `红球${tabKey.length > 1 ? tabKey : '0'+tabKey}` : `前区${tabKey.length > 1 ? tabKey : '0'+tabKey}`">
                    <el-table 
                        :data="generateTableData(tabKey)" 
                        style="width: 50%" border
                        :default-sort="{ prop: 'number', order: 'ascending' }">
                        <el-table-column prop="number" label="号码" />
                        <el-table-column prop="count" label="次数" />
                        <el-table-column label="详情">
                            <template #default="{ row }">
                            <el-button @click="showDetail(row, followData[tabKey][row.number])">详情</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-dialog custom-class="custom-dialog" :visible.sync="dialogVisible" title="详情">
                        <div class="dialog-content">
                            <h3>{{ currentLottery === 'ssq' ? '红球' : '前区' }} {{ selectedRow.number }} 跟随详情，共 {{ selectedRow.count }} 次</h3>
                            <div class="scrollable-content">
                                <div v-for="(item, index) in detailData" :key="index" class="detail-item">
                                    <p>第 {{ item.current.lottery_no }} 期 {{ item.current.lottery_res_red.split(',').join(' ')+'+'+item.current.lottery_res_blue }}</p>
                                    <p>第 {{ item.next.lottery_no }} 期 {{ item.next.lottery_res_red.split(',').join(' ')+'+'+item.next.lottery_res_blue }}</p>
                                </div>
                            </div>
                            
                        </div>
                    </el-dialog>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
import { getAnalyzeFollowerList } from '../../api/tool'
export default {
    data() {
        return {
            dialogVisible: false,
            currentLottery: 'ssq',
            selectedBalls: [],
            followData:[],
            tableData: [
                { number: '01', count: 123 },
                { number: '02', count: 100 },
                // ...其他数据
            ],
            selectedRow: {},
            detailData:[]
        }
    },
    computed:{
        ballRange() {
            return this.currentLottery === 'ssq' ? 33 : 35
        },
        maxSelection() {
            return this.currentLottery === 'ssq' ? 6 : 5
        },
        canGenerate() {
            return  this.selectedBalls.length >= 1 && 
                    this.selectedBalls.length <= this.maxSelection
        },
    },
    methods: {
        generateTableData(tabKey) {
            return Object.keys(this.followData[tabKey]).map(num => ({
                number: num,
                count: this.followData[tabKey][num].length
            }));
        },
        showDetail(row, detailArray) {
            console.log(row,'row')
            this.selectedRow = row;
            this.detailData = detailArray || [];
            this.dialogVisible = true;
        },
        formatResult(item) {
            return `${item.lottery_res_red.split(',').join(' ')} + ${item.lottery_res_blue}`;
        },
        clearAll(){
            this.selectedBalls = [];
            this.followData = [];
            this.detailData = [];
            this.dialogVisible = false;
        },
        toggleBall(n) {
            const index = this.selectedBalls.indexOf(n)
            if (index === -1) {
                if (this.selectedBalls.length < this.maxSelection) {
                    this.selectedBalls.push(n)
                    this.selectedBalls.sort((a, b) => a - b)
                } else {
                    this.$message.warning(`最多只能选择${this.maxSelection}个号码`)
                }
            } else {
                this.selectedBalls.splice(index, 1)
            }
            console.log(this.selectedBalls,'this.selectedBalls')
        },
        generateCombinations(){
            let param = {
                lottery_id: this.currentLottery == 'ssq' ? 1 : 3, 
                limit: 0, 
                type: "red", 
                numbers: this.selectedBalls
            }
            getAnalyzeFollowerList(param).then(res => {
                this.followData = res.data.data;
                console.log(res.data.data,'res')
            })
        }
    }
}
</script>
<style scoped>
.historyData-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    font-family: "Microsoft YaHei", sans-serif;
    h1{
        text-align: center;
        color: #f44336;
        margin-bottom: 20px;
    }
}
.lottery-selector {
    text-align: center;
    margin-bottom: 30px;
}
.box-card, .filter-card {
    margin-bottom: 20px;
}

.ball-area {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.ball {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-weight: bold;
    user-select: none;
    transition: all 0.3s;
    background-color: #f8f8f8;
    border: 1px solid #ddd;
}
.ball.red {
    color: #f44336;
    border-color: #f44336;
}

.ball.front {
    color: #f44336;
    border-color: #f44336;
}

.ball.selected {
    color: white;
}

.ball.selected.red {
    background-color: #f44336;
}

.ball.selected.front {
    background-color: #f44336;
}
.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}
.clearfix:after {
    clear: both;
}
.control-area {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin: 30px 0;
}
.result-area {
    margin-top: 30px;
}
.container {
  display: flex;
}
/* 确保弹窗在最顶层 */
.el-dialog__wrapper {
  z-index: 9999 !important;
}
.custom-dialog {
  /* 设置弹窗最大高度 */
  max-height: 70vh !important;
  display: flex;
  flex-direction: column;
}

/* 弹窗内容区域 */
.dialog-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* 可滚动内容区域 */
.scrollable-content {
  flex: 1;
  overflow-y: auto;
  max-height: calc(70vh - 120px); /* 减去标题和边距高度 */
  padding-right: 10px; /* 避免滚动条遮挡内容 */
  margin-top: 10px;
}

/* 每个详情项的样式 */
.detail-item {
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}

/* 滚动条样式 */
.scrollable-content::-webkit-scrollbar {
  width: 6px;
}
.scrollable-content::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 3px;
}
@media (max-height: 800px) {
  .custom-dialog {
    max-height: 60vh !important;
  }
  .scrollable-content {
    max-height: calc(60vh - 120px);
  }
}
</style>


// WEBPACK FOOTER //
// src/views/usingTools/numFollow.vue